<template>
  <div class="model-content">
    <div
      class="model_68"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <img class="img-box" :src="url" />

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>
      <div class="food_name">
        <div class="food_name_text">{{ posterList.food_name }}</div>
      </div>

      <div class="food_img">
        <img :src="posterList.food_img" alt="" />
      </div>

      <div class="food_price" :style="{ fontSize: posterList.fontSize + 'px' }">
        <span class="number">{{ posterList.food_price }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_68",
  data() {
    return {
      posterList: {},
      url: require("../../img/poster/model_68.png"),
    };
  },
  created() {
    this.canvasfortitle(
      this.$route.query?.merchant_name || "",
      this.$route.query?.food_name || "",
      this.$route.query
    );
  },
  methods: {
    /**
     * 处理标题和食物名称以生成海报的canvas数据
     *
     * @param merchant_name 商家名称
     * @param food_names 食物名称
     * @param query 查询参数，包括食物价格等
     */
    canvasfortitle(merchant_name = "", food_names = "", query = {}) {
      const MAX_MERCHANT_LENGTH = 40;
      const MAX_FOOD_LENGTH = 36;
      const replaceParentheses = (str = "") => {
        return String(str).replace(/[()（）]/g, (match) =>
          match === "(" || match === "（" ? "-" : " "
        );
      };
      const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length <= maxLength
          ? text
          : `${text.substring(0, maxLength)}...`;
      };
      const res_name = replaceParentheses(merchant_name);
      const food_name = replaceParentheses(food_names);
      this.posterList = {
        ...query,
        merchant_name: truncateText(res_name, MAX_MERCHANT_LENGTH),
        food_name: truncateText(food_name, MAX_FOOD_LENGTH),
        food_price: parseFloat(query.food_price) || 0,
      };
      const priceLength = String(this.posterList.food_price).replace(
        ".",
        ""
      ).length;
      const fontSizeMap = {
        3: 46,
        4: 38,
        5: 30,
        6: 28,
      };
      this.posterList.fontSize = fontSizeMap[priceLength] || 48;
    },
  },
};
</script>

<style scoped>
@import url("../../css/model_65/merchant_title.css");
.model-content {
  width: 750px;
  height: 283px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_68 {
  width: 750px;
  height: 283px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 24px;
  right: 50px;
  transform: rotate(-6deg);
  color: #fff;
  width: 300px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.model_ug .merchant-name-title {
  font-family: "Nurjanbay Kufi Chong" !important;
  font-size: 23px;
  line-height: 44px;
  padding: 2px 0;
}
.model_zh .merchant-name-title {
  font-family: "FZCQK--GBK1-0" !important;
  line-height: 32px;
  font-size: 26px;
}

.food_name {
  position: absolute;
  width: 290px;
  top: 150px;
  right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  text-align: center;
}

.food_name_text {
  color: #ffd200;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.model_ug .food_name_text {
  font-family: "Nurjanbay Kufi Chong" !important;
  font-size: 28px;
  line-height: 30px;
  padding: 3px 0;
  font-variant: unicase;
}
.model_zh .food_name_text {
  font-family: "FZCQK--GBK1-0" !important;
  line-height: 34px;
  font-size: 30px;
}

.food_img {
  position: absolute;
  top: 61px;
  left: 20px;
  width: 308px;
  height: 190px;
  border-radius: 50%;
  overflow: hidden;
  mix-blend-mode: multiply;
}

.food_img img {
  width: 100%;
  height: 100%;
  clip-path: ellipse(50% 50% at 50% 50%);
  object-fit: cover;
}

.food_price {
  position: absolute;
  width: 110px;
  height: 90px;
  top: 160px;
  left: 323px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  color: #d70000;
  font-weight: bold;
  flex-direction: column;
}

.number {
  font-family: "UzluqEgme" !important;
}
</style>
